import styled from 'styled-components';

import { basicSmallTextStyle, Button } from '@dreryk/react-components';

export const StyledTileItemPrimaryButton = styled(Button)`
   ${basicSmallTextStyle}
   border: none;
`;

StyledTileItemPrimaryButton.displayName = 'StyledTileItemPrimaryButton';
